import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class TrackOrdersService {

    constructor(private _http: HttpClient) { }

    getorders(data) {
        return this._http.post(environment.api_url+'admin/trackorders',data);
    }

    acceptqcorder(data) {
        return this._http.post(environment.api_url+'buyer/order/acceptqcstatus',data);
    }

    acceptrejectreturn(data) {
        return this._http.post(environment.api_url+'admin/returnrequest/approve',data);
    }

    initpickup(data) {
        return this._http.post(environment.api_url+'admin/returnrequest/updatestatus',data);
    }

}
